// Compatibility shim for v-mask -> maska
import { vMaska } from "maska"

// ponytail: legacy `v-mask="'##.##.####'"` puts the mask in the binding value,
// but maska v2 writes its result object there and expects the mask in `arg`.
function adapt(binding) {
  return typeof binding.value === "string" || Array.isArray(binding.value)
    ? { ...binding, value: null, arg: { ...binding.arg, mask: binding.value } }
    : binding
}

export const mask = {
  mounted: (el, binding) => vMaska(el, adapt(binding)),
  updated: (el, binding) => vMaska(el, adapt(binding)),
}
export const VueMaskDirective = mask
export const VueMaskFilter = value => value // No-op filter

export default {
  install(app) {
    app.directive("mask", mask)
  },
}
